import React from 'react';
import { HeaderSection, HeaderTitle, HeaderSpan } from '../../MetricPanel/styled';
import FrustrationSignalControl from '../control';

const Header = () => {
  return (
    <HeaderSection>
      <HeaderTitle>
        Frustration Signals
        <HeaderSpan>Beta</HeaderSpan>
      </HeaderTitle>
      <FrustrationSignalControl />
    </HeaderSection>
  );
};

export default Header;
